// @mui
import { Box, Button } from '@mui/material';
// config
import { HOST_API } from '../../../config';
// assets
import workwiseLogo from '../../../assets/icons/workwise-logo.png';

// The Keycloak redirect lives on the Laravel backend at /auth/keycloak/redirect
// (session-backed PKCE state — registered in routes/web.php, NOT routes/api.php).
// HOST_API already carries the /api suffix used by axios; strip it here so the
// browser navigates straight to the backend origin's web route.
const SSO_REDIRECT_URL = `${HOST_API.replace(/\/api\/?$/, '')}/auth/keycloak/redirect`;

// ----------------------------------------------------------------------

type Props = {
  onClick?: () => void;
  // BIZH-XXXX — reused by the forgot-password interstitial: override the label
  // and the navigation target (the WorkWise reset-credentials URL) while keeping
  // the same brand button. Defaults preserve the login "Sign in with WorkWise".
  label?: string;
  redirectUrl?: string;
};

// ----------------------------------------------------------------------
//
// BIZH-1190 — "Sign in with WorkWise" button. Layout per the PM-supplied
// login mockup: primary contained brand-blue button, full-width, large
// size, WorkWise brand mark on the left, label "Sign in with WorkWise".
//
// The button is the primary CTA on the login page — it sits ABOVE the
// legacy Auth2FAForm with an "OR SIGN IN BELOW" divider beneath it.
//
// The brand mark is the official WorkWise logo PNG supplied by PM,
// imported from src/assets/icons/workwise-logo.png, rendered at its
// native colours (white W + turquoise terminal).
//
// ----------------------------------------------------------------------

// REMOVE WITH KEYCLOAK_SSO_ENABLED — cleanup epic
export default function SsoSignInButton({ onClick, label = 'Sign in with WorkWise', redirectUrl }: Props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.href = redirectUrl ?? SSO_REDIRECT_URL;
    }
  };

  return (
    <>
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: '<!-- REMOVE WITH KEYCLOAK_SSO_ENABLED — cleanup epic -->' }} />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        onClick={handleClick}
        sx={{ '& .MuiButton-startIcon': { mr: 0 } }}
        startIcon={
          <Box
            component="img"
            src={workwiseLogo}
            alt=""
            sx={{
              width: 60,
              height: 60,
              objectFit: 'contain',
            }}
          />
        }
      >
        {label}
      </Button>
    </>
  );
}
